const calculateSuma = data =>
  data
    ? data
        .reduce(function (acc, cur) {
          return acc.concat(cur.zdroje);
        }, [])
        .reduce(function (acc, cur) {
          return acc + (cur.pocet || 0);
        }, 0)
    : 0;

export default calculateSuma;
